var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
var LegacyBoundary = (function (_super) {
    __extends(LegacyBoundary, _super);
    function LegacyBoundary() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = { error: undefined };
        return _this;
    }
    LegacyBoundary.prototype.unstable_handleError = function (error) {
        var _a = this.props, appsignal = _a.instance, action = _a.action, _b = _a.tags, tags = _b === void 0 ? {} : _b, override = _a.override;
        var name = error.name, message = error.message, stack = error.stack;
        var span = appsignal.createSpan();
        span
            .setError({
            name: name,
            message: message,
            stack: stack
        })
            .setTags(__assign({ framework: "Legacy React" }, tags));
        if (action && action !== "")
            span.setAction(action);
        if (override) {
            span = override(span, error);
        }
        appsignal.send(span);
        this.setState({ error: error });
    };
    LegacyBoundary.prototype.render = function () {
        return (React.createElement("div", null, !this.state.error
            ? this.props.children
            : this.props.fallback
                ? this.props.fallback(this.state.error)
                : null));
    };
    LegacyBoundary.defaultProps = {
        action: ""
    };
    return LegacyBoundary;
}(React.Component));
export { LegacyBoundary };
//# sourceMappingURL=LegacyBoundary.js.map